export class DrugPricing {
    clientId: string;
    quantity: number;
    groupId: string;
    cardholderId: string;
    npi: string;
    ndc: string;
    awpUnitPrice: number;
    price: string;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/pharmacy-locator/models/drug-pricing.ts